module.exports = __webpack_public_path__ + "img/01_icon_3.8a3adedc.svg";